import { TOS } from './components';
import { IModule } from 'core/rootInterfaces/root.interface';

export const tosModule: IModule = {
  moduleName: 'tos',
  path: '/tos',
  component: TOS,
  reducer: null,
};
